module.exports = __webpack_public_path__ + "media/images/logo--primary--white-0a20a81fa7089f14d28eb6ea2471dd04.svg";